import { Injectable } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor() {}

  convertToJavascriptDate(ngbDate: NgbDateStruct): Date {
    return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
  }

  convertToNgbDateStruct(date: Date): NgbDateStruct {
    date = new Date(date); //converts to javascript date if not already
    const ngbDate: NgbDateStruct = {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };

    return ngbDate;
  }

  getMinBirthday(): string {
    const today = new Date();

    return today.getMonth() + 1 + '/' + today.getDate() + '/' + (today.getFullYear() - 150);
  }

  getMaxBirthday(): string {
    const today = new Date();

    return today.getMonth() + 1 + '/' + today.getDate() + '/' + (today.getFullYear() - 15);
  }

  getPreviousDay(): string {
    const today = new Date();

    return today.getMonth() + 1 + '/' + (today.getDate() - 1) + '/' + today.getFullYear();
  }

  getCurrentDay(): string {
    const today = new Date();

    return today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear();
  }

  isValidDate(date: Date | undefined | null): boolean {
    return !!date && date instanceof Date && !isNaN(date.getTime());
  }

  getCurrentDayAndTime(): string {
    const today = new Date();

    return today.toLocaleDateString() + ' ' + today.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  }

  getDatesBetween(startDate: string, endDate: string, dates: string[]): string[] {
    return dates.filter((x) => new Date(x) >= new Date(startDate) && new Date(x) <= new Date(endDate));
  }

  convertMonthYearToDate(date: string, day = 1) {
    const [month, year] = date.split('/');

    const transformedDate = new Date(parseInt(year), parseInt(month) - 1, day);

    return transformedDate;
  }

  getFiscalYearEndYearForDate(dateLike?: Date | string | null): string {
    const d = this.toDate(dateLike);
    if (!d) return '';

    const startMonth = 7; // July
    const month = d.getMonth() + 1; // 1-based month
    const year = d.getFullYear();

    const startYear = month >= startMonth ? year : year - 1;
    const endYear = startYear + 1;
    return String(endYear);
  }

  getCurrentFiscalYearEndYearString(): string {
    const d = new Date();

    const startMonth = 7; // July
    const month = d.getMonth() + 1; // 1-based month
    const year = d.getFullYear();

    const startYear = month >= startMonth ? year : year - 1;
    const endYear = startYear + 1;
    return String(endYear);
  }

  toDate(dateLike?: Date | string | null): Date | null {
    if (!dateLike) return null;
    if (dateLike instanceof Date) {
      return isNaN(dateLike.getTime()) ? null : dateLike;
    }
    const parsed = new Date(dateLike);
    return isNaN(parsed.getTime()) ? null : parsed;
  }
}
